package com.essntl.features.task.ui.sharedtask

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class SharedTaskViewModel(
    private val itineraryRepository: ItineraryRepository,
    val state: MutableStateFlow<SharedTaskState> = MutableStateFlow(SharedTaskState()),
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {
    fun getAllItineraries(ids: Set<String>) =
        getData(
            getData = { itineraryRepository.getAllByIds(ids.toList()) },
            getState = { state.value.getAllItineraries },
            setState = { newState ->
                state.update {
                    it.copy(
                        getAllItineraries = State.success(
                            state.value.getAllItineraries.data.orEmpty() + newState.data.orEmpty(),
                        ),
                    )
                }
            },
        )

    fun editClient(
        client: ClientModel,
        itinerary: ItineraryModel,
    ) =
        scope.launch {
            state.emit(
                state.value.copy(
                    getAllItineraries = state.value.getAllItineraries.copy(
                        data = state.value.getAllItineraries.data
                            .orEmpty()
                            .map { i ->
                                if (i.id == itinerary.id)
                                    i.copy(proposal = i.proposal?.copy(primaryClient = client)) else
                                    i
                            },
                    ),
                ),
            )
        }
}